import { FunctionComponent, useContext } from 'react';

import {
  CheckedCalendarIcon,
  ClockIcon,
  OtherWorkerIcon,
  RunningManIcon,
} from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { LocalizationContext } from 'localization';
import { getLastClientActivityText } from 'utils';

import { CollapsibleItem } from '../CollapsibleItem';
import s from './AdditionalInfo.module.scss';
import { IAdditionalInfoProps } from './interfaces';

export const AdditionalInfo: FunctionComponent<IAdditionalInfoProps> = ({
  registrationDate,
  lastActivity,
  timeSpent = 0,
  defaultState,
  firstName,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <CollapsibleItem title={t('client.more')} defaultState={defaultState}>
      <div className={s.container}>
        {firstName && (
          <div className={s.row}>
            <OtherWorkerIcon size="m" color="link-info" />
            {firstName}
          </div>
        )}
        <div className={s.row}>
          <CheckedCalendarIcon size="m" color="link-info" />
          {dayjs(registrationDate).format('DD.MM.YYYY')}
        </div>
        <div className={s.row}>
          <RunningManIcon size="m" color="link-info" />
          {getLastClientActivityText(lastActivity, t)}
        </div>
        <div className={s.row}>
          <ClockIcon size="m" color="link-info" />
          {t('clients.spentHours', timeSpent.toString())}
        </div>
      </div>
    </CollapsibleItem>
  );
};
